import { RGB } from '@da-g3-acl/shared/common/colour-types';

import { LaneThickness } from '../../../../types/imageTypeMetadata';
import { CoreLaneRowType, LaneRowConfiguration } from '../configurations';

import { Bounds } from './useGradients';

export interface Point {
	at: number;
	value: number;
}

export interface PointData {
	isLoading: boolean;
	points: Point[];
}
interface NumericLaneRowDisplayConfigurationBase {
	type: PointDataLaneRowDisplayType;
}

export enum PointDataLaneRowDisplayType {
	Points,
	Gradients,
}

export type PointsScaleProvider = (value: number, domain: [number, number]) => number;

export type PointsNumericLaneRowDisplayConfiguration = NumericLaneRowDisplayConfigurationBase & {
	type: PointDataLaneRowDisplayType.Points;
	shape?: 'circle' | 'bar';
	scaleProvider?: PointsScaleProvider;
	colourProvider?: ColourProviderResolver;
};

export type ColourProviderResolver = (bounds: Bounds) => ColourProvider;

export type ColourProvider = { value: number; colour: RGB }[];
export type GradientsNumericLaneRowDisplayConfiguration = NumericLaneRowDisplayConfigurationBase & {
	type: PointDataLaneRowDisplayType.Gradients;
	colourProvider?: ColourProviderResolver;
	showPoints?: boolean;
};

export type NumericLaneRowDisplayConfiguration =
	| PointsNumericLaneRowDisplayConfiguration
	| GradientsNumericLaneRowDisplayConfiguration;
export type NumericPoint = { at: number; value: number; rulerAt: number | undefined };

export type PointLaneRowMouseEventCallbackFn = (hoveredItem: { point: NumericPoint; colour: RGB } | undefined) => void;

export interface NumericLaneRowConfiguration extends LaneRowConfiguration {
	type: CoreLaneRowType.Numeric;
	displayConfiguration: NumericLaneRowDisplayConfiguration;
	points: NumericPoint[];
	valueBounds: Bounds;
	thickness?: LaneThickness;
	pointIndicatorConfig?: { sizePx: number; thresholdScale: number };
	onHover?: PointLaneRowMouseEventCallbackFn;
}
